const AUTH_UPDATE_USER_INFO = 'user/AUTH_UPDATE_USER_INFO';

export const loadUser = user => {
  return {
    type: AUTH_UPDATE_USER_INFO,
    data: user
  };
};

const initialState = {
  idTokenData: {
    name: '',
    s_name: ''
  }
};

export const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case AUTH_UPDATE_USER_INFO:
      return { ...state, idTokenData: action.data };
    default:
      return state;
  }
};

export default userReducer;



// WEBPACK FOOTER //
// ./src/common/jsx/ducks/user.js